enum Page {
  DESIGN_STUDIO_SHARE_VIEW = 'Design-studio-share-view',
  DESIGN_STUDIO = 'Design-studio',
  COMPLETE_PROFILE__INPUT = 'Complete-profile_input',
  FORGOT_PASSWORD__INPUT = 'Forgot-password_input',
  HOMEOWNER_ACCOUNT__INPUT = 'Homeowner-account_input',
  HOMEOWNER_DOWNLOAD_SENT = 'Homeowner-download-sent',
  HOMEOWNER_DOWNLOAD__INPUT = 'Homeowner-download_input',
  LOGIN__INPUT = 'Login_input',
  PASSWORD_EMAIL_SENT = 'Password-email-sent',
  PROFESSIONAL_ACCOUNT__INPUT = 'Professional-account_input',
  RESET_PASSWORD_ERROR__INPUT = 'Reset-password-error_input',
  RESET_PASSWORD_SUCCESS = 'Reset-password-success',
  RESET_PASSWORD__INPUT = 'Reset-password_input',
  SIGNUP__FORK = 'Signup_fork',
  SSO_COMPLETE_PROFILE__INPUT = 'SSO-complete-profile_input',
  SSO_EMAIL__INPUT = 'SSO-email_input',
  SSO_LOGIN_FAILURE = 'SSO-login-failure',
  SSO_LOGIN_SUCCESS = 'SSO-login-success',
  SSO_LOGIN__INPUT = 'SSO-login_input',
  SSO_SIGNING_ON = 'SSO-signing-on',
  SSO_USERNAME__INPUT = 'SSO-username_input',
  TERMS_OF_SERVICE = 'Terms-of-service',
}

export { Page };
